export { DEP_YATIVERSE } from './dynamic';

// App
export const APP_ANONYMOUS_LANDING_PAGE = '/start';

// Auth
export const AUTH_SIGN_IN = '/auth/login';

// Profile
export const YAT_PROFILE_PAGE = '/profile';

// Yat Picker
export const YAT_PICKER_CHECKOUT = '/checkout';
